import Constant from '../common/Constant';

export function getFreshUser(firebaseUser) {
  const user = {
    uid: firebaseUser.uid,
    email: firebaseUser.email,
    companyName: '',
    companyImageURL: '',
    defaultCurrency: Constant.DEFAULT_CURRENCY_CODE,
  };

  return user;
}



// WEBPACK FOOTER //
// ./src/helpers/user.js